import React from 'react';
import JobCategoryPage from './JobCategoryPage';
import { Brain } from 'lucide-react';

const BehavioralHealthSocialWorkerJobs = () => {
  return (
    <JobCategoryPage
      category="behavioral-health-social-worker-jobs"
      title="Behavioral Health Social Worker Jobs"
      metaTitle="Behavioral Health Social Worker Jobs (LCSW, LMSW) | INeedASocialWorker.com"
      metaDescription="Find behavioral health and mental health social worker jobs nationwide. LCSW, LMSW, and LBSW roles in psychiatric, substance abuse, and community mental health settings."
      heroTitle="Behavioral Health Social Worker Jobs"
      heroSubtitle="Mental health, psychiatric, and substance-use social work roles for licensed clinicians (LCSW, LMSW, LBSW) across the United States."
      searchKeywords={['behavioral health', 'mental health social worker', 'LCSW', 'substance abuse counselor', 'psychiatric social worker']}
      iconComponent={Brain}
      contentSections={[
        {
          title: 'What Behavioral Health Social Workers Do',
          content: 'Behavioral health social workers provide assessment, therapy, crisis intervention, and case management for people living with mental illness, trauma, and substance-use disorders. They work in community mental health centers, psychiatric hospitals, integrated primary-care clinics, and telehealth practices.',
          list: [
            'Individual, group, and family psychotherapy',
            'Biopsychosocial assessments and treatment planning',
            'Crisis intervention and safety planning',
            'Substance-use disorder counseling and recovery support',
            'Care coordination with psychiatrists and primary care',
          ],
        },
        {
          title: 'Licensing & Requirements',
          content: 'Most clinical behavioral health roles require an LCSW for independent practice, while LMSW clinicians typically practice under supervision toward clinical licensure. Employers value experience with evidence-based modalities such as CBT, DBT, and motivational interviewing.',
        },
        {
          title: 'Where the Jobs Are',
          content: 'Demand is strongest in community mental health, integrated care, telehealth, and substance-use treatment. Many roles offer clinical supervision hours, loan-repayment eligibility, and flexible or remote scheduling.',
        },
      ]}
      relatedCategories={[
        { name: 'Hospital Social Worker Jobs', href: '/hospital-social-worker-jobs' },
        { name: 'Medical Social Worker Jobs', href: '/medical-social-worker-jobs' },
        { name: 'Community & Government Jobs', href: '/community-social-worker-jobs' },
      ]}
    />
  );
};

export default BehavioralHealthSocialWorkerJobs;
